import { getUsefulInfoDetail } from "./UlGUIULUIP02/GUIULUIP02Reducer";
import { updateUsefulInfoDetail } from "./UlGUIULUIP01/GUIULUIP01Reducer";

export const uiReducer = {
    getUsefulInfoDetail,
    updateUsefulInfoDetail
};
